import { useGilt, useTranslation } from 'providers/GILT.provider';
import { formatDateByLocale, formatTimeByLocale } from 'utils/date/format.util';
import { nowAsDate } from 'utils/date/now.util';

import ChangeLocaleDropdown from 'scheduler/components/Header/ChangeLocaleDropdown.component';

import CN from './GiltPage.module.scss';

const GiltPage = () => {
  const { locale } = useGilt();
  const { t } = useTranslation();

  const now = nowAsDate();

  return (
    <div data-bem="GiltPage" className={CN.container}>
      <div className={CN.component}>
        <div className={CN.topBar}>
          <span className={CN.languageTitle}>Change language</span>
          <ChangeLocaleDropdown />
        </div>
        <div className={CN.horizontalFlex}>
          <div className={CN.panel}>
            <h2>Locale</h2>

            <table>
              <tr>
                <td>Dates</td>
                <td>{formatDateByLocale(now, { locale })}</td>
              </tr>
              <tr>
                <td></td>
                <td>{formatDateByLocale(now, { locale, dateFormat: 'll' })}</td>
              </tr>
              <tr>
                <td></td>
                <td>{formatDateByLocale(now, { locale, dateFormat: 'LL' })}</td>
              </tr>

              <tr>
                <td>Times</td>
                <td>{formatTimeByLocale(now, { locale })}</td>
              </tr>
              <tr>
                <td></td>
                <td>{formatTimeByLocale(now, { locale, dateTimeFormat: 'LTS' })}</td>
              </tr>
              <tr>
                <td>Dates & Times</td>
                <td>{formatDateByLocale(now, { locale, dateFormat: 'lll' })}</td>
              </tr>
              <tr>
                <td></td>
                <td>{formatDateByLocale(now, { locale, dateFormat: 'LLL' })}</td>
              </tr>
              <tr>
                <td></td>
                <td>{formatDateByLocale(now, { locale, dateFormat: 'llll' })}</td>
              </tr>
              <tr>
                <td></td>
                <td>{formatDateByLocale(now, { locale, dateFormat: 'LLLL' })}</td>
              </tr>
            </table>
          </div>

          <div className={CN.panel}>
            <h2>Translations</h2>

            <table>
              <tr>
                <td>Clothing</td>
                <td>{t('experiment.clothing')}</td>
              </tr>
              <tr>
                <td>Food</td>
                <td>{t('experiment.food')}</td>
              </tr>
              <tr>
                <td>General</td>
                <td>{t('experiment.general')}</td>
              </tr>
              <tr>
                <td>Spelling</td>
                <td>{t('experiment.spelling')}</td>
              </tr>
              <tr>
                <td>Quotation</td>
                <td>{t('experiment.quotation')}</td>
              </tr>
              <tr>
                <td>Conjugation</td>
                <td>{t('experiment.conjugation')}</td>
              </tr>
              <tr>
                <td>Preposition</td>
                <td>{t('experiment.preposition')}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GiltPage;
